import { gql } from '@apollo/client'
import { Heading } from '@farol-ds/react'
import classNames from 'classnames'
import { ReactNode } from 'react'

import { useSendViewItemEvent } from '../../hooks/use-send-view-item-event'
import { PaywallLock_OfferLockDataFragment } from './__generated__/paywall-lock.graphql'
import styles from './paywall.module.scss'

interface PaywallLockProps {
  children: ReactNode
  className?: string | null
  title?: string
  offerLockData: PaywallLock_OfferLockDataFragment
}
export function PaywallLock(props: PaywallLockProps) {
  const { children, className, offerLockData, title } = props

  const { sendViewItemRef } = useSendViewItemEvent({ offerLockBody: offerLockData.body })
  const paywallContainerClassnames = classNames(styles.paywall, className)
  return (
    <div className={paywallContainerClassnames} ref={sendViewItemRef}>
      {!!title && (
        <Heading
          size="lg"
          className={styles.paywallLockTitle}
          data-testid="paywall-lock-header-title"
        >
          {title}
        </Heading>
      )}
      {children}
    </div>
  )
}

PaywallLock.fragments = {
  offerLockData: gql`
    fragment PaywallLock_offerLockData on OfferLockData {
      body {
        ...UseSendViewItemEvent_offerLockBody
      }
    }

    ${useSendViewItemEvent.fragments.offerLockBody}
  `,
}
